import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import DropdownField from 'pf9-ui-components/built/components/validatedForm/DropdownField'
import TextField from 'pf9-ui-components/built/components/validatedForm/TextField'
import React, { useState } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import { volumeSizeValidator } from 'core/utils/fieldValidators'
import ClusterVMSourceType from './ClusterVMSourceType'

interface SourcePoolFieldsProps {
  onChange: (value: Record<string, any>) => void
  nodePool: Record<string, any>
}

const useStyles = makeStyles<Theme>((theme) => ({
  warningContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  warningSpacing: {
    marginRight: theme.spacing(1),
  },
  warningColor: {
    color: theme.palette.warning.main,
  },
}))

const SourcePoolFields = ({ nodePool, onChange }: SourcePoolFieldsProps) => {
  const classes = useStyles()
  const [noVolumeTypes, setNoVolumeTypes] = useState(false)

  return (
    <>
      <div>
        <DropdownField
          id="clusterVmSourceType"
          DropdownComponent={ClusterVMSourceType}
          label="Boot VM From"
          onChange={(value) => onChange({ bootingSource: value })}
          value={nodePool.bootingSource}
          onNoVolumeTypes={setNoVolumeTypes}
          required
        />
        {noVolumeTypes && (
          <div className={classes.warningContainer}>
            <FontAwesomeIcon className={clsx(classes.warningSpacing, classes.warningColor)}>
              info-circle
            </FontAwesomeIcon>
            <Text variant="body2" className={classes.warningColor}>
              Unable to boot from volume, no volume types available. Please add a volume type to
              boot from volume.
            </Text>
          </div>
        )}
      </div>

      {nodePool.bootingSource && nodePool.bootingSource !== 'image' && (
        <>
          <TextField
            id="clusterVmVolumeSize"
            label="Volume Size (GiB)"
            onChange={(value) => onChange({ volumeSize: value })}
            value={nodePool.volumeSize}
            type="number"
            validations={[volumeSizeValidator(20)]}
            min={20}
            info="Volume size should be equivalent to virtual disk size of an image or more"
            required
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            crossOrigin={undefined}
          />
        </>
      )}
    </>
  )
}

export default SourcePoolFields
